// extracted by mini-css-extract-plugin
export default {"container":"slide__container___e7mGu","container-full-width":"slide__container-full-width___3NiHV"};